import React from 'react'
import { FormatNumberMXN } from "../../common/Utils";

export const ColumnsOrderHistoryChangeErrorsInvoices = (t) => (
    [
        {
            name: t('OrderInvoceChange.OrderHistoryChangeErrorsInvoices.File'),
            columnheader: {textAlign: 'center'},
            selector: 'ErrorFileNm',
            sortable: false,
            width: "30%",
            cell: row => row.errorFileNm
        },
        {
            name: t('OrderInvoceChange.OrderHistoryChangeErrorsInvoices.DateToDiscovery'),
            selector: 'AuditInsertSrt',
            columnheader: {textAlign: 'center'},
            center: true,
            sortable: false,
            width: "20%",
            cell: row => row.auditInsertSrt
        },
        {
            name: t('OrderInvoceChange.OrderHistoryChangeErrorsInvoices.MessageError'),
            selector: 'ErrorMsgVal',
            columnheader: {textAlign: 'center'},
            sortable: false,
            width: "50%",            
            cell: row => row.errorMsgVal
        }      
    ]
)

  